import { Box, Container, Image, Link } from '@chakra-ui/react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import skolkovoLogo from 'assets/img/logos/skolkovo-logo.svg';
import emailIcon from 'assets/img/icons/email.svg';
import telegramIcon from 'assets/img/icons/telegram.svg';

import styles from './styles.module.scss';

const Footer: FC = () => {
  const { t } = useTranslation();

  return (
    <Box className={styles.footer} minW="980px">
      <Container className={styles.footerContainer}>
        <div className={styles.footerLeft}>
          <div className={styles.skolkovoRow}>
            <Link
              href="https://sk.ru"
              target="_blank"
            >
              <Image
                className={styles.skolkovoLogo}
                src={skolkovoLogo}
                width="96px"
                height="70px"
                alt=""
              />
            </Link>
            <div>
              <h6 className={styles.skolkovoTitle}>
                {t('skolkovoResidentTitle')}
              </h6>
              <span>{t('skolkovoResidentDescription')}</span>
            </div>
          </div>
          <p className={styles.copyrightText}>{t('copyright1')}</p>
          <p className={styles.copyrightText}>{t('copyright2')}</p>
          <p className={styles.copyrightText}>
            {t('copyright3', { year: new Date().getFullYear() })}
          </p>
        </div>
        <div className={styles.footerRight}>
          <div className={styles.contacts}>
            <div className={styles.contactRow}>
              <span className={styles.contactRowLabel}>
                {t('addressLabel')}
              </span>
              <Link
                href="https://yandex.com/maps/-/CCUSQFUUHC"
                target="_blank"
                className={styles.contactRowValue}
              >
                {t('addressValue')}
              </Link>
            </div>
            <div className={styles.contactRow}>
              <div className={styles.contactRowLabel}>
                <span>{t('phoneLabel')}</span>
              </div>
              <div className={styles.contactRowValue}>
                <Link target="_blank" href="tel:88006004717">
                  8 800 600-47-17
                </Link>
                <br />
                <Link target="_blank" href="tel:+74957904717">
                  +7 495 790-47-17
                </Link>
              </div>
            </div>
            <div className={styles.contactRow}>
              <span className={styles.contactRowLabel}>{t('emailLabel')}</span>
              <Link
                className={styles.contactRowValue}
                target="_blank"
                href="mailto:info@sharespro.ru"
              >
                info@sharespro.ru
              </Link>
            </div>
          </div>
          <div className={styles.resources}>
            <Link
              className={styles.resourceLink}
              target="_blank"
              href="https://docs.sharespro.ru/privacy_policy.pdf"
            >
              {t('privacyPolicy')}
            </Link>
            <Link
              className={styles.resourceLink}
              target="_blank"
              href="https://docs.sharespro.ru/terms_of_service.pdf"
            >
              {t('userAgreement')}
            </Link>
            <Link
              className={styles.resourceLink}
              target="_blank"
              href="https://docs.sharespro.ru/result_1788345.pdf"
            >
              {t('soutResults')}
            </Link>
            <div className={styles.socials}>
              <Link href="https://tlgg.ru/sharespro" target="_blank">
                <Image src={telegramIcon} width="40px" height="40px" alt="" />
              </Link>
              <Link href="mailto:info@sharespro.ru" target="_blank">
                <Image src={emailIcon} width="44px" height="32px" alt="" />
              </Link>
            </div>
          </div>
        </div>
      </Container>
    </Box>
  );
};

export default Footer;
